import { Link } from "react-router-dom";
interface DeleteModalProps {
  onDelete: () => void; // A function with no arguments that returns void
  modalId: string; // A string for the modal ID
  message?: string; // Optional string for the custom message
  title?: string; // Optional string for the custom title
}
const DeleteModal: React.FC<DeleteModalProps> = ({
  onDelete,
  modalId,
  message,
  title,
}) => {
  return (
    <div className="modal fade" id={modalId}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
              <i className="ti ti-trash-x fs-36" />
            </span>
            <h4 className="mb-1">{title || "Confirm Delete"}</h4>
            <p className="mb-3">
              {message ||
                "Are you sure you want to delete this? This action cannot be undone."}
            </p>
            <div className="d-flex justify-content-center">
              <Link
                to="#"
                className="btn btn-light me-3"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <Link
                to="#"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={onDelete}
              >
                Yes, Delete
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
